import { all, fork, take } from 'redux-saga/effects';
import { damzOnline } from '../actions/initialization';

// Import sub-sagas
import { roomManagementSaga } from './room/room-management';
import { roomMessageFetchingSaga } from './room/room-message-fetching';
import { roomMessageActionsSaga } from './room/room-message-actions';
import { roomTypingSaga } from './room/room-typing';
import { roomActionsSaga } from './room/room-actions';
import { roomUnreadSaga } from './room/room-unread';
import { roomDmCardDataSaga } from './room/room-dm-card-data';

/**
 * Main room saga orchestrator
 */
export function* roomSaga() {
  yield take(damzOnline); // wait for online to happen
  yield all([
    fork(roomManagementSaga),
    fork(roomMessageFetchingSaga),
    fork(roomMessageActionsSaga),
    fork(roomTypingSaga),
    fork(roomActionsSaga),
    fork(roomUnreadSaga),
    fork(roomDmCardDataSaga),
  ]);
}
